module.exports = __webpack_public_path__ + "img/baac.3a66a764.png";